// update state
const setUserRoleAction = (payload) => {
    return {
        type: "ROLE",
        payload
    }

}

export default setUserRoleAction;




// WEBPACK FOOTER //
// ./src/actions/setUserRoleAction.js